/* Chrome Drop — "what you'll pay with your code" prices. 2026-09-05 (re-added on the Plinko theme; first built for Warehouse Flight 2026-09-03).
   When a player presses APPLY & SHOP THE SALE, ci-chrome-drop.js puts the code on the cart (Cart API, REPLACING any earlier code)
   and remembers { code, k, p, at } under localStorage.ciChromeDrop.applied. This script asks Shopify which game code the cart
   holds (the cart is the truth; the locker is only the fallback when /cart.js fails), then fills the placeholder that
   snippets/price.liquid renders under every product price (cards, PDP, quick-add) with the price after the code, and drops
   a one-line strip at the top of sale pages. Codes are recognised by name only: CHROMEDROP15/30/50, CHROMETEE, CHROME100
   (+ the older CHROMEFLIGHT* names). If the cart has items and the held code is dead (cap reached / deactivated), it swaps
   in the next tier down from the ladder the game stored, so nobody reaches checkout with a code that errors. */
(function () {
  'use strict';
  var KEYS = ['ciChromeDrop', 'ciChromeFlight'], TTL = 86400000 /* 2026-09-07 (owner): codes live 24h from the win */, info = null, code = '';
  function known(c) {
    c = String(c || '').toUpperCase().trim();
    if (!c) return null;
    if (/SECRET/.test(c)) return { kind: 'pct', p: 60, label: 'UNRELEASED PIECE + 60% OFF', short: '60%' };
    if (/SHORTS/.test(c)) return { kind: 'shorts', p: 0, label: 'FREE SHORTS', short: 'FREE SHORTS' }; /* 2026-09-17: free tee prize became free shorts (any other item unlocks it) */
    if (/TEE/.test(c)) return { kind: 'tee', p: 0, label: 'FREE TEE', short: 'FREE TEE' };
    var m = c.match(/^CHROME(?:FLIGHT|DROP)?(\d{2,3})(?:\b|-)/);
    if (m) { var p = parseInt(m[1], 10); if (p > 0 && p <= 100) return { kind: 'pct', p: p, label: p + '% OFF', short: p + '%' }; }
    return null;
  }
  function lockers() {
    var out = [];
    for (var i = 0; i < KEYS.length; i++) {
      try { var s = JSON.parse(localStorage.getItem(KEYS[i]) || '{}'); if (s && typeof s === 'object') out.push({ key: KEYS[i], s: s }); } catch (e) {}
    }
    return out;
  }
  function locker() {
    var ls = lockers();
    for (var i = 0; i < ls.length; i++) {
      var a = ls[i].s.applied;
      if (a && a.code && a.at && (Date.now() - a.at) < TTL) return a.code;
    }
    return '';
  }
  /* pct ladder the game stored ([{k,p,code}], best first) — used only to step DOWN when a code is dead */
  function ladder() {
    var ls = lockers();
    for (var i = 0; i < ls.length; i++) if (Array.isArray(ls[i].s.ladder) && ls[i].s.ladder.length) return ls[i].s.ladder;
    return [];
  }
  /* 2026-09-07: when does this code die? 24h after the win the game logged (locker), else 24h after APPLY; 0 = unknown (ad link / typed code) */
  function expiresAt(c) {
    var k = known(c);
    if (!k || !c) return 0;
    var key = k.p ? 'd' + k.p : k.kind, ls = lockers();
    for (var i = 0; i < ls.length; i++) {
      var s = ls[i].s, w = s.w || {};
      if (w[key]) return w[key] + TTL;
      if (s.applied && s.applied.at && String(s.applied.code || '').toUpperCase() === String(c).toUpperCase()) return s.applied.at + TTL;
    }
    return 0;
  }
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function fmtLeft(ms) { var s = Math.max(0, Math.floor(ms / 1000)); return pad2(Math.floor(s / 3600)) + ':' + pad2(Math.floor((s % 3600) / 60)) + ':' + pad2(s % 60); }
  function remember(c) {
    var k = known(c);
    try {
      var s = JSON.parse(localStorage.getItem(KEYS[0]) || '{}');
      s.applied = { code: c, k: k ? (k.p ? 'd' + k.p : k.kind) : '', p: k ? k.p : 0, at: Date.now() };
      localStorage.setItem(KEYS[0], JSON.stringify(s));
    } catch (e) {}
  }
  function fmt(sample, cents) {
    var m = String(sample || '').match(/^(.*?)1([.,])00(.*)$/);
    var pre = m ? m[1] : '£', sep = m ? m[2] : '.', suf = m ? m[3] : '';
    return pre + (Math.round(cents) / 100).toFixed(2).replace('.', sep) + suf;
  }
  var cssDone = false;
  function css() {
    if (cssDone) return; cssDone = true;
    var st = document.createElement('style');
    st.textContent = '.ci-code-badge{display:none}.price--sold-out .ci-code-badge{display:none!important}' +
      '.price .ci-code-badge.is-on{display:block;width:100%;margin:.4rem 0 0;font-size:1.15rem;line-height:1.35;letter-spacing:.04em;color:#F97E83;text-transform:uppercase;font-weight:800}' +
      '.ci-code-badge b{font-weight:900;color:#F97E83}' +
      '.ci-code-badge i{display:block;font-style:normal;font-weight:600;font-size:.92em;color:#9a9ea8;text-transform:none;letter-spacing:.02em;white-space:normal;overflow-wrap:anywhere}' +
      '.price--large .ci-code-badge.is-on{font-size:1.4rem;margin-top:.7rem}' +
      '.ci-code-strip{margin:0 0 1.6rem;padding:1rem 1.4rem;border:1px solid #D94146;background:#1e1f23;color:#e8e9ec;font-size:1.15rem;letter-spacing:.06em;text-transform:uppercase;font-weight:700;text-align:center;line-height:1.6}' +
      '.ci-code-strip b{color:#F97E83}.ci-code-strip__tick{color:#F97E83;margin-right:.4rem}' +
      '.ci-code-strip__code{display:inline-block;margin-left:.6rem;padding:.1rem .6rem;border:1px dashed #3a3c44;letter-spacing:.1em;color:#9a9ea8}' +
      '.ci-code-strip__exp{display:inline-block;margin-left:.6rem;color:#ff3b3b;font-weight:800;font-variant-numeric:tabular-nums;letter-spacing:.08em}' +
      '@media (max-width:749px){.price .ci-code-badge.is-on{font-size:.95rem;letter-spacing:.02em;white-space:nowrap}.ci-code-strip{font-size:1rem;padding:.9rem 1rem;margin:0 0 1.2rem}}';
    document.head.appendChild(st);
  }
  function narrow() { try { return window.matchMedia('(max-width: 749px)').matches; } catch (e) { return false; } }
  function decorate() {
    /* 2026-09-06 (owner): the per-product "£X with your code" prices are OFF — the code shows in the bag only, product pages stay clean. Placeholders stay display:none. */
    return;
    if (!info) return;
    var els = document.querySelectorAll('[data-ci-code-badge]:not([data-ci-done])');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      el.setAttribute('data-ci-done', '1');
      var cents = parseInt(el.getAttribute('data-cents'), 10);
      if (isNaN(cents)) continue;
      var isTee = el.getAttribute('data-tee') === '1', isShorts = el.getAttribute('data-shorts') === '1', html;
      if (info.kind === 'tee') {
        /* 2026-09-05: the free-tee code needs SHORTS in the bag (was: any other item) */
        /* 2026-09-06: short lines — the long sentences inherited the phone nowrap rule below and pushed the page to 448px wide */
        /* 2026-09-19 (owner): back to any other item — one tee free with anything else in the bag */
        html = isTee ? '<b>FREE</b> with your code<i>with any other item in your bag</i>' : '<i>Add a tee, it’s free with this</i>';
      } else if (info.p >= 100) {
        html = '<b>FREE</b> with your 100% code';
      } else {
        /* 2026-09-06 (owner): one line only — phones drop "your" so "£18.50 with 50% code" never wraps */
        html = '<b>' + fmt(el.getAttribute('data-fmt'), Math.round(cents * (100 - info.p) / 100)) + '</b> with ' + (narrow() ? '' : 'your ') + info.p + '% code';
      }
      el.innerHTML = html;
      el.classList.add('is-on');
    }
  }
  function strip() {
    if (!info || document.querySelector('[data-ci-cd]') || document.querySelector('.ci-code-strip')) return;
    var main = document.getElementById('MainContent');
    if (!main || !document.querySelector('[data-ci-code-badge]')) return;
    var d = document.createElement('div');
    d.className = 'ci-code-strip';
    d.innerHTML = '<span class="ci-code-strip__tick">&#10003;</span>YOUR <b>' + info.label + '</b> CODE IS APPLIED. ' +
      (info.kind === 'shorts' ? 'add shorts plus any other item and the shorts come off in your bag' : (info.kind === 'tee' ? 'add a tee plus any other item and the tee comes off in your bag' : 'it comes off in your bag')) +
      ' <span class="ci-code-strip__code">' + code.replace(/[<>&]/g, '') + '</span>';
    main.insertBefore(d, main.firstChild);
    /* 2026-09-07 (owner): the code dies 24h after the win — count it down on the strip; at zero the strip goes (the bag guard drops the code) */
    var exp = expiresAt(code);
    if (exp) {
      var xe = document.createElement('span');
      xe.className = 'ci-code-strip__exp';
      d.appendChild(xe);
      var tick = function () {
        var left = exp - Date.now();
        if (left <= 0) { clearInterval(iv); if (d.parentNode) d.parentNode.removeChild(d); return; }
        xe.textContent = 'EXPIRES IN ' + fmtLeft(left);
      };
      var iv = setInterval(tick, 1000);
      tick();
    }
  }
  function run() { css(); decorate(); strip(); }
  function post(discount) {
    return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: discount }) })
      .then(function (r) { return r.json(); });
  }
  function resolve(cb) {
    var fallback = locker();
    if (!window.fetch) { cb(fallback); return; }
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var dcs = (c && c.discount_codes) || [];
      var list = dcs.map(function (d) { return String(d.code || ''); });
      var game = list.filter(known), pick = '';
      /* the code the player pressed APPLY on last wins if Shopify still holds it; otherwise the most recently added
         game code (Shopify appends, so last = newest) */
      for (var i = 0; i < game.length; i++) if (fallback && game[i].toUpperCase() === fallback.toUpperCase()) pick = game[i];
      if (!pick && game.length) pick = game[game.length - 1];
      var items = (c && c.item_count) || 0;
      /* dead code (cap reached / switched off) while the bag has items → step down the pct ladder so checkout never errors.
         An empty bag also reports applicable:false for perfectly good codes, so only judge with items in the bag. */
      if (pick && items > 0) {
        var held = null;
        for (var j = 0; j < dcs.length; j++) if (String(dcs[j].code).toUpperCase() === pick.toUpperCase()) held = dcs[j];
        var pk = known(pick);
        if (held && held.applicable === false && pk && pk.kind === 'pct') {
          var lad = ladder(), next = '';
          for (var q = 0; q < lad.length; q++) if (lad[q] && lad[q].code && lad[q].p < pk.p && (!next || lad[q].p > known(next).p)) next = lad[q].code;
          if (next && next.toUpperCase() !== pick.toUpperCase()) {
            post(next).then(function (c2) {
              var ok = c2 && c2.discount_codes && c2.discount_codes.some(function (d) { return String(d.code).toUpperCase() === next.toUpperCase() && d.applicable !== false; });
              if (ok) remember(next);
              cb(ok ? next : pick);
            }).catch(function () { cb(pick); });
            return;
          }
        }
      }
      /* self-heal: the old /discount/ links could stack two game codes and Shopify keeps honouring the older one —
         collapse the cart to the chosen code (only when every code on the cart is one of ours) */
      if (pick && game.length > 1 && game.length === list.length) post(pick).catch(function () {});
      /* Shopify's cart is the truth: no game code on it means nothing is applied (checkout done, code removed, cart expired) —
         the locker only stands in when the cart request itself fails */
      cb(pick);
    }).catch(function () { cb(fallback); });
  }
  if (!document.querySelector('[data-ci-code-badge]')) return;
  resolve(function (c) {
    info = known(c); code = c || '';
    if (!info) return;
    run();
    /* prices re-render on variant change, quick-add, pagination and infinite scroll — keep filling new placeholders */
    var pending = null;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; decorate(); }, 80);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  });
})();
